import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericCRUDService } from 'src/app/shared/services';
import { EquipamentoGrupo } from '../equipamento.model';
import { Pagination } from 'src/app/shared/models';

@Injectable({
    providedIn: 'root'
})
export class EquipamentoGrupoService extends GenericCRUDService {

    constructor(http: HttpClient) {
        super(http);
        this.url = `/admin/equipamentos-grupo`;
    }

    createEquipamentoGrupo(object: EquipamentoGrupo): Observable<EquipamentoGrupo> {
        const form = this.getFormData(object);
        return this.http.post<EquipamentoGrupo>(`${this.url}`, form);
    }

    updateEquipamentoGrupo(id: string, grupo: EquipamentoGrupo): Observable<EquipamentoGrupo> {
        const newGrupo = Object.assign({}, grupo)
        if (typeof newGrupo.tipo === 'object') {
            newGrupo.tipo = grupo.tipo.id;
        }
        if (newGrupo.imagens && newGrupo.imagens.length > 0) {
            newGrupo.imagens = newGrupo.imagens.filter((img) => img instanceof File);
        }
        const form = this.getFormData(newGrupo);
        return this.http.patch<EquipamentoGrupo>(`${this.url}/${id}`, form);
    }

    removeImage(idImg: string): Observable<any> {
        return this.http.delete(`${this.url}/imagens/${idImg}`);
    }

    override getPaginated<EquipamentoGrupo>(page: number, pageSize: number, nome?: string): Observable<Pagination<EquipamentoGrupo>> {
        const params = new URLSearchParams();
        params.append('page', `${page}`);
        params.append('pageSize', `${pageSize}`);
        nome && params.append('nome', `${nome}`);
        return this.http.get<Pagination<EquipamentoGrupo>>(`${this.url}?${params}`);
    }

    private getFormData(object: any) {
        const formData: FormData = new FormData();
        for (const key in object) {
            if (Array.isArray(object[key])) {
                for (const imgKey in object[key]) {
                    formData.append(key, object[key][imgKey]);
                }
            } else {
                formData.append(key, object[key] || '');
            }
        }
        return formData;
    }


}
